import {
    checkMergeDetail,
    //巡检tab栏完成查询
    checkSubDetail
} from "@/api/patrol/index";
const patrol = {
    state: {
        data:{
            active:false,
            device:false,
            problem:false,
            suggestion:false
        }
    },
    actions: {
        checkSubDetail(context){
            checkSubDetail({
                subId:JSON.parse(window.sessionStorage.getItem("subId")).id
            }).then((res)=>{
                context.commit('setData', res.data.data)
            })
        },
        checkMergeDetail(context){
            checkMergeDetail({
                infoMergeId:JSON.parse(window.sessionStorage.getItem("infoData")).infoMergeId
            }).then((res)=>{
                context.commit('setData', res.data.data)
            })
        }
    },
    mutations: {
        setData(state,payload){
            state.data = payload;
        }
    },
    getters: {

    },
    namespaced: true
}
export default patrol
